'use strict';
import {AjaxFactory} from './AjaxFactory';
import {HttpMethod} from './enums';
import {getQueryParams} from './defaultPageFactory';

/**
 * @param {ReduxObservableListOptions} options
 */
export function buildSyncListFactory(options) {
  return new AjaxFactory(buildListSyncRequestOptions(options));
}

/**
 * @param {ReduxObservableListOptions} options
 * @return {AjaxFactoryOptions}
 */
export function buildListSyncRequestOptions(options) {
  return {
    crossDomain: options.crossDomain,
    method: HttpMethod.POST,
    useBody: true,
    url: getListSyncUrl(options),
    getToken: options.getToken,
    getBody,
    serializeBody,
  };
}

/**
 * @typedef {ListPageRequest} ListSyncPageRequest
 * @property {Object} body
 */

/**
 * @param {ReduxObservableListOptions} options
 * @return {Function}
 */
export function getListSyncUrl(options) {
  /**
   * @param {ListSyncPageRequest} request
   */
  return function getListUrlCurried(request) {
    return `${options.baseApiUrl}/${getListSyncPath(options, request.parentId)}?${getQueryParams(options, request)}`;
  }
}

function getListSyncPath(options, parentId) {
  if (options.hasParentId) {
    return options.listSyncPath(parentId);
  } else {
    return options.listSyncPath;
  }
}

/**
 * @param {ListSyncPageRequest} request
 * @return {any}
 */
function getBody(request) {
  return request.body;
}

/**
 * @param {ListSyncPageRequest} request
 * @return {String}
 */
function serializeBody(request) {
  return JSON.stringify(request.body);
}



// WEBPACK FOOTER //
// ./src/js/_libs/redux-observable-list/src/defaultSyncListFactory.js